module.exports = __webpack_public_path__ + "static/media/paleta.9e560ad9.jpeg";